export { CompilationWatchView, type CompilationWatchViewProps } from "./CompilationWatchView";
